// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"505f320f","455":"01cb062f","977":"af6de507"}[chunkId] + ".chunk.js";
};